import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';

import Button from '../../components/ButtonCustom';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { formatDateToDDMMYYYYFrEpoch, getCurrencySymbol } from '../../utils/util';
import Container from '../../components/Container';
import InfiniteScroll from 'react-infinite-scroll-component';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { ReorderIcon, ReOrderIconNew1 } from '../../components/icons';
import t from '../../utils/translateUtil';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { Currencies } from '../../../Currencies';

const styles = theme => ({
    boxItemContainer: {
        position: 'relative'
    },
    boxItemContent: {
        padding: theme.spacing(4, 4, 4, 4),
        marginTop: theme.spacing(2),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
    status: {
        marginLeft: theme.spacing(4),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        ...theme.palette.button.success,
    },
    reorder: {
        position: 'absolute',
        zIndex: 999,
        top: theme.spacing(6),
        right: theme.spacing(4),
        cursor: 'pointer'
    },
    supply_method: {
        color: theme.palette.button.primary.backgroundColor,
    },
    reorder_icon: {
        fill: theme.palette.button.primary.backgroundColor,
    },
    filter_item: {
        padding: theme.spacing(2),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.info,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.info,
        },
        '&:focus': {
            ...theme.palette.button.info,
            border: 'none',
            outline: 'none'
        }
    },
    filter_item_selected: {
        padding: theme.spacing(2),
        margin: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.shape.borderRadius5x,
        ...theme.palette.button.primary,
        cursor: 'pointer',
        minWidth: 60,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        touchAction: "manipulation",
        'white-space': 'nowrap',
        '&:active': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        },
        '&:hover': {
            ...theme.palette.button.primary,
        },
        '&:focus': {
            ...theme.palette.button.primary,
            border: 'none',
            outline: 'none'
        }
    }
});

function OrderHistoryView(props) {
    const { classes, t, showLoading, my_orders, currency, onShowDetail, hasMore, handleLoadMore, showLoadMore, filterSelected } = props
    let status = [
        { label: "All", value: 'All' },
        { label: "Completed", value: 'COMPLETED' },
        { label: "Cancelled", value: "CANCELLED" },
        { label: "New", value: 'NEW' },
        { label: "Pending", value: 'PENDING' },
    ]

    //console.log('OrderHistoryView my_orders====',my_orders)
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.onClose()}
                title={t('order_history')}
                children={<Grid item>
                    <Grid item xs={12} marginBottom={2}
                    >
                        <ScrollMenu
                            alignCenter={false}
                        >
                            {status.map((item, index) =>
                                <div key={index} onClick={() => props.setFilter(item.value)} className={filterSelected === item.value ? classes.filter_item_selected : classes.filter_item}>
                                    <CustomTypo>{item.label}</CustomTypo>
                                </div>
                            )}
                        </ScrollMenu>
                    </Grid>
                    {showLoading && <CustomizedCircularProgress />}
                    <Grid xs={12} item>
                        <InfiniteScroll
                            dataLength={my_orders.length} //This is important field to render the next data
                            next={handleLoadMore}
                            hasMore={hasMore}
                            height={window.innerHeight}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        >
                            <Grid xs={12} item container>
                                {my_orders.map((item, index) => (
                                    <OrderItem item={item} key={index} classes={classes} t={t} onReorder={props.onReorder} onShowDetail={onShowDetail} currency={currency} />
                                ))}</Grid>
                        </InfiniteScroll>

                    </Grid>
                </Grid>} />
        </div>
    );
}
function OrderItem(props) {
    const { classes, onShowDetail, item, currency, t } = props
    let currency_symbol = currency;
    currency_symbol = getCurrencySymbol(item.currency ? item.currency : null);
    return (
        <Grid item xs={12} className={classes.boxItemContainer}>
            <Grid xs={12} container className={classes.boxItemContent} onClick={() => onShowDetail(item)}>
                <Grid xs={12} item container alignItems='center'>
                    <Grid item xs={8}>
                        {item.fulfilled_by && <CustomTypo variant='subtitle2'>{item.fulfilled_by.name}</CustomTypo>}
                    </Grid>

                </Grid>
                <Grid xs={12} item container alignItems='center'>
                    <Grid xs={8} item container justify='flex-start'>
                        {item.submitted_date && <CustomTypo variant='body1' color='secondary' >{formatDateToDDMMYYYYFrEpoch(item.submitted_date)}</CustomTypo>}
                    </Grid>
                    <Grid xs={4} item container direction='row' alignItems='center' justify='flex-end'>
                        <Button className={classes.status} size="xs" color={"success"}>{dataUtil.getLCSName(item.life_cycle_state)}</Button>
                        {item.supply_method && <CustomTypo variant="body2" mg_left_sm className={classes.supply_method}>{getSupplyMethod(item.supply_method)}</CustomTypo>}
                    </Grid>
                </Grid>
                <Grid xs={12} item container alignItems='center'>
                    <CustomTypo mg_right_sm mg_top_sm variant='subtitle1'>{currency_symbol}{item.total_cost.toFixed(2)}</CustomTypo>
                </Grid>

            </Grid>
            {item.supply_method !== 'DIRECT_SALE' && <Grid item container justify='flex-end' onClick={() => props.onReorder(item)} className={classes.reorder}>
                <CustomTypo variant='body1' color='primary' style={{ color: '#3498db' }} mg_right_sm>
                    <ReOrderIconNew1 className={classes.reorder_icon} />
                </CustomTypo>
            </Grid>}
            {/* <Products products={item.order_items} /> */}
        {/* <Products products={item.order_items} /> */}
        </Grid>
    )
}
function getSupplyMethod(method) {
    if (method == 'PICK_UP') {
        return t('pickup');
    } else if (method == 'DELIVERY') {
        return t('delivery');
    } else if (method == 'DIRECT_SALE') {
        return t('direct_sale');
    }
}
export default withStyles(styles)(withTranslation()(OrderHistoryView));